export enum ProfesionalEstado {
  pendienteDoc = "PENDIENTE_DOCUMENTACION",
  apto = "APTO",
  suspendido = "SUSPENDIDO",
}
